'use client';
import Script from 'next/script';

const trackerId = process.env.NEXT_PUBLIC_ZAIUS_TRACKER_ID;

const ZaiusScript = () => {
  if (!trackerId) return null;

  return (
    <Script
      id="zaius-init"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{
        __html: `
          var zaius = window['zaius'] || (window['zaius'] = []);
          zaius.methods = ["initialize","onload","customer","entity","event","subscribe","unsubscribe","consent","identify","anonymize","dispatch"];
          zaius.factory = function(method) {
            return function() {
              var args = Array.prototype.slice.call(arguments);
              args.unshift(method);
              zaius.push(args);
              return zaius;
            };
          };
          (function() {
            for (var i = 0; i < zaius.methods.length; i++) {
              var method = zaius.methods[i];
              zaius[method] = zaius.factory(method);
            }
            var s = document.createElement("script");
            s.type = "text/javascript";
            s.async = true;
            s.src = (document.location.protocol === "https:" ? "https://" : "http://") +
              "d1igp3oop3iho5.cloudfront.net/v2/${trackerId}/zaius-min.js";
            var head = document.getElementsByTagName("script")[0];
            head.parentNode.insertBefore(s, head);
          })();
        `,
      }}
    />
  );
};

export default ZaiusScript;
